import { theme } from '@global-engineering-shared/gweb-global-theme';
import { makeStyles } from '@material-ui/core';

type Props = {
  statusColour: string;
};

const useStyles = makeStyles(() => ({
  statusMessage: {
    textAlign: 'left',
    gridColumn: 2,
  },
  container: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: theme.spacing(2),
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    columnGap: theme.spacing(1),
  },
  statusMessageIcon: (props: Props) => ({
    color: `${props.statusColour}`,
    marginRight: theme.spacing(1),
  }),
}));

export default useStyles;
